// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 1px !important;
  border: none !important;
  --border-radius: 16px !important;
}

ion-input {
  --border: none !important;
  color: var(--ion-color-secondary);
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent ;
}

.wrapper {
  padding: 20px;
}

.privacy {
  font-size: 12px;
  color: var(--ion-color-black);
}
.privacy ion-button {
  padding: 0px;
  color: var(--ion-color-primary);
  text-transform: capitalize;
}

.privacy-btn {
  margin-left: 5px;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  --border-radius: 5px;
  margin-bottom: 0;
}

.stacked {
  position: relative;
  z-index: 2;
  left: 20px;
  top: 7px;
  background: white;
  padding: 0px 5px;
}

.terms {
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
}

ion-checkbox {
  margin-left: 0px;
}

.stacked {
  position: static;
  top: 0px;
  left: 0px;
  z-index: 2;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-secondary);
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: var(--ion-color-secondary);
}
.input-age ion-input:first-child {
  border-right: 1px solid #CBD5E1;
}
.input-age ion-input:last-child {
  border-left: 1px solid #CBD5E1;
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  margin: 10px 0px;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}
.button-wrapper ion-button ion-icon {
  margin-right: 10px;
  zoom: 0.9;
}
.button-wrapper ion-button.google {
  --background: #D0463B;
}
.button-wrapper ion-button.facebook {
  --background: #3B5997;
}
.button-wrapper ion-button.apple {
  --background: black;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-up/sign-up.page.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;AADF;;AAIA;EACE,QAAA;EACA,kBAAA;AADF;;AAGA;EACE,8BAAA;EACA,uBAAA;EACA,gCAAA;AAAF;;AAEA;EACE,yBAAA;EACA,iCAAA;EACA,gCAAA;AACF;;AACA;EACE,kBAAA;EACA,0BAAA;AAEF;;AAAA;EACE,aAAA;AAGF;;AADA;EACE,eAAA;EACA,6BAAA;AAIF;AAHE;EACE,YAAA;EACA,+BAAA;EACA,0BAAA;AAKJ;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,eAAA;EACA,mBAAA;AAKF;;AAFA;EACE,oBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAKF;;AAFA;EAEE,gBAAA;AAIF;AAHE;EACE,kBAAA;AAKJ;;AADA;EACE,gBAAA;AAIF;;AAAA;EACC,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAGD;;AADA;EACE,oCAAA;EACA,eAAA;EACA,iCAAA;AAIF;;AADE;EACE,YAAA;EACA,kBAAA;EACA,iCAAA;AAIJ;AAFE;EACE,+BAAA;AAIJ;AAFE;EACE,8BAAA;AAIJ;;AADA;EACE,yBAAA;EACA,gBAAA;AAIF;;AAFA;EACE,YAAA;EACA,mBAAA;AAKF;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAMF;AALE;EACE,WAAA;EACA,gBAAA;AAOJ;AALE;EACE,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AAMJ;AALI;EACI,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAOR;AALI;EACI,kBAAA;EACA,SAAA;AAOR;AALI;EACI,qBAAA;AAOR;AALI;EACI,qBAAA;AAOR;AALI;EACI,mBAAA;AAOR","sourcesContent":["@import \"../../../theme/mixins\";\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n  gap: 5px;\n  margin-bottom: 8px;\n}\nion-item {\n  --border-width: 1px !important;\n  border: none !important;\n  --border-radius: 16px !important;\n}\nion-input {\n  --border: none !important;\n  color: var(--ion-color-secondary);\n  font-family: AppFont, sans-serif;\n}\n.no-line {\n  border-bottom: 0px;\n  --background: transparent\n}\n.wrapper{\n  padding: 20px;\n}\n.privacy{\n  font-size: 12px;\n  color: var(--ion-color-black);\n  ion-button {\n    padding: 0px;\n    color: var(--ion-color-primary);\n    text-transform: capitalize;\n  }\n}\n.privacy-btn{\n  margin-left: 5px;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\nion-item {\n  --border-radius: 5px;\n  margin-bottom: 0;\n}\n\n.stacked {\n  position: relative;\n  z-index: 2;\n  left: 20px;\n  top: 7px;\n  background: white;\n  padding: 0px 5px;\n}\n\n.terms {\n\n  margin-left: 0px;\n  ion-checkbox {\n    margin-right: 10px;\n  }\n}\n\nion-checkbox {\n  margin-left: 0px;\n}\n\n\n.stacked {\n\tposition: static;\n\ttop: 0px;\n\tleft: 0px;\n\tz-index: 2;\n}\nion-label {\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  color: var(--ion-color-secondary);\n}\n.input-age {\n  ion-input {\n    height: 100%;\n    text-align: center;\n    color: var(--ion-color-secondary);\n  }\n  ion-input:first-child {\n    border-right: 1px solid #CBD5E1;\n  }\n  ion-input:last-child {\n    border-left: 1px solid #CBD5E1;\n  }\n}\nion-footer {\n  --background: transparent;\n  box-shadow: none;\n}\n.loading {\n  height: 50vh;\n  align-items: center;\n}\n.button-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  ion-button {\n    width: 100%;\n    margin: 10px 0px\n  }\n  ion-button {\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    p {\n        margin-top: 5px;\n        font-family: AppFontBold, sans-serif;\n        color: white;\n        width: 75%;\n    }\n    ion-icon {\n        margin-right: 10px;\n        zoom: 0.9;\n    }\n    &.google {\n        --background: #D0463B;\n    }\n    &.facebook {\n        --background: #3B5997;\n    }\n    &.apple {\n        --background: black;\n    }\n}\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
